import ComptrollerDataTable from 'pages/comptroller/comptroller-table/ComptrollerDataTable';
import { useMemo, useState } from 'react';

import viewIcon from 'assets/images/table-icons/view_blue.svg';

import { Button, Spin, Tooltip } from 'antd';
import { isEmpty } from 'lodash';
import { numberFormatter } from 'utils/utils';

function ListViewBudgetaryControl({ data, isLoading, showModal, setItem }) {
	const [rowSelection, setRowSelection] = useState([]);

	const COLUMNS = useMemo(
		() => [
			// {
			// 	id: 'Selection',
			// 	align: 'center',
			// 	onClicked: true,
			// 	cellAlign: 'center',
			// 	Cell: ({ row, index }) => <IndeterminateCheckbox id={index} {...row.getToggleRowSelectedProps()} />,
			// 	Header: ({ getToggleAllRowsSelectedProps, index }) => (
			// 		<IndeterminateCheckbox id={index + '1'} sx={{ color: 'white', padding: '0px' }} {...getToggleAllRowsSelectedProps()} />
			// 	),
			// },
			{
				Header: 'Budget Code',
				accessor: 'budgetCode',
			},
			{
				Header: 'Year',
				accessor: 'budgetYear',
			},
			// {
			// 	Header: 'Case No',
			// 	accessor: 'lynUniqueId',
			// },
			{
				Header: 'Initial Plan',
				cellAlign: 'right',
				accessor: (data) => (data?.budgetAmount ? numberFormatter(data.budgetAmount) : '-'),
			},
			{
				Header: 'Transfers',
				cellAlign: 'right',
				accessor: (data) => (data?.transferredOutAmount ? numberFormatter(data.transferredOutAmount) : '-'),
			},
			{
				Header: 'Unapproved Transfers',
				cellAlign: 'right',
				accessor: (data) => (data?.transferReservedAmount ? numberFormatter(data.transferReservedAmount) : '-'),
			},
			{
				Header: 'Current Plan',
				cellAlign: 'right',

				accessor: (data) => (data?.adjustedAmount ? numberFormatter(data.adjustedAmount) : '-'),
			},
			{
				Header: 'Unapproved Budget Release',
				cellAlign: 'right',
				accessor: (data) => (data?.reservedAmount ? numberFormatter(data.reservedAmount) : '-'),
			},
			{
				Header: 'Approved Budget Release',
				cellAlign: 'right',
				accessor: (data) => (data?.consumedAmount ? numberFormatter(data.consumedAmount) : '-'),
			},
			{
				Header: 'Unavailable Budget',
				cellAlign: 'right',
				accessor: (data) => (data?.unavailableAmount ? numberFormatter(data.unavailableAmount) : '-'),
			},
			{
				Header: 'Current Available Budget',
				cellAlign: 'right',
				accessor: (data) => (data?.freeAmount ? numberFormatter(data.freeAmount) : '-'),
			},
			{
				Header: 'Projected Plan',
				cellAlign: 'right',
				accessor: (data) => (data?.projectedAdjustedAmount ? numberFormatter(data.projectedAdjustedAmount) : '-'),
			},
			{
				Header: 'Budget Held Up',
				cellAlign: 'right',
				accessor: (data) => (data?.heldAmount ? numberFormatter(data.heldAmount) : '-'),
			},
			{
				Header: 'Projected Available Budget',
				cellAlign: 'right',

				accessor: (data) => (data?.projectedFreeAmount ? numberFormatter(data.projectedFreeAmount) : '-'),
			},
			{
				align: 'center',
				Header: 'Action',
				disableSortBy: 'true',
				Cell: (cell) => (
					<div style={{ textAlign: 'center' }}>
						<Tooltip title="View">
							<Button
								type="text"
								icon={<img src={viewIcon} width={16} height={16} alt="view" />}
								onClick={(e) => {
									e.stopPropagation();
									showModal();
									setItem(cell.row.original.id);
								}}
							></Button>
						</Tooltip>

						{/* <Tooltip title="Edit">
							<Button
								type="text"
								icon={<img src={editIcon} width={16} height={16} alt="edit" />}
								onClick={(e) => {
									e.stopPropagation();
									//   navigate("/static/function/edit", { state: { functionMasterList, editList: cell.row.original, tab: searchParams.get("tab") } });
									// console.log('cell.row.original', cell.row.original);
								}}
							></Button>
						</Tooltip> */}
					</div>
				),
			},
		],
		[]
	);

	return (
		<Spin spinning={isLoading} style={{ maxHeight: '100%' }}>
			<ComptrollerDataTable
				onClickHandler={() => {}}
				DATA={isEmpty(data) ? [] : data}
				rowSelection={rowSelection}
				setRowSelection={setRowSelection}
				COLUMNS={COLUMNS}
				xlsxFileName="budgetary-control"
			/>
		</Spin>
	);
}

export default ListViewBudgetaryControl;
